import React, { useEffect, useState } from "react";

import Input from "../components/Input";
import { Link } from "react-router-dom";
import { ArrowLeft, Search } from "react-feather";
import axiosInstance from "../apis/gvmdesk";
import useAxiosFunction from "../hooks/useAxiosFunction";
import { useAuth } from "../providers/auth";
import LoadingCenter from "../components/LoadingCenter";
import { CAvatar, CFormCheck } from "@coreui/react";
import { useMutation } from "@tanstack/react-query";
import { useHttp } from "../hooks/useHttp";
import openToast from "../utils/sweetAlert";

const ChainsNew = props => {
  const [name, setName] = useState("");

  const request = useHttp();
  const register = () => { };

  /**
   *
   *
   *
   *
   *
   *
   */
  const { user } = useAuth();
  const [search, setSearch] = useState("");
  const [visible, setVisible] = useState(false);
  const [contacts, setContacts] = useState(null);
  const [response, setResponse, loading, error, axiosFetch] = useAxiosFunction();
  const [contactsCount, setContactsCount] = useState(null);

  const clearVariables = () => {
    setSearch("");
    setResponse(null);
    setContacts(null);
    setContactsCount(0);
    setVisible(false);
  }

  useEffect(() => {
    clearVariables();
  }, []);

  useEffect(() => {
    if (user) {
      axiosFetch({
        axiosInstance,
        method: "GET",
        url: "/users",
        redirect_to: ""
      });
    }
  }, []);

  useEffect(() => {
    setContacts(response?.map(contact => {
      return {
        ...contact,
        checked: false
      };
    }));
  }, [response]);

  useEffect(() => {
    if (contacts?.length > 0) {
      let selectedContacts = contacts?.filter(contact => contact.checked == true);

      setVisible(selectedContacts.length > 0);
      setContactsCount(selectedContacts.length);
    }
  }, [contacts]);

  const onChangeCheck = (event, contact) => {
    let { checked } = event.target;

    setContacts(contacts.map(oldContact => {
      if (contact.id === oldContact.id) {
        oldContact.checked = checked;
      }

      return oldContact;
    }));
  }

  const onChangeAll = event => {
    let { checked } = event.target;

    setContacts(contacts.map(contact => {
      contact.checked = checked;

      return contact;
    }));
  }

  const avatarStyle = avatarPicture => ({
    width: "45px",
    height: "45px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundImage: `url(${avatarPicture})`
  });

  const mutationChainsCreate = useMutation(["mutation-chains-create"], data => request({ url: "/chains", method: "POST", data: data }), {
    onSuccess: res => {
      if (res.data.error) {
        openToast("error", "Ocorreu um erro", res.data.message);
      }

      if (!res.data.error) {
        openToast("success", "Sucesso", res.data.message);
      }
    }
  });

  const onSubmit = (event) => {
    event.preventDefault();

    let selectedContacts =
      contacts.filter(contact => contact.checked == true);

    let users_id = selectedContacts.map(contact => {
      return contact.id;
    });

    mutationChainsCreate.mutate({ name, users_id });
  }

  const filteredConsumers = search.length > 0
    ? contacts?.filter(contact => contact.name.includes(search))
    : contacts;

  return (
    <div className="d-flex flex-column">
      <div className="header border-bottom border-top-right-radius-8">
        <div className="d-flex flex-row align-center">
          <Link to="/chains" className="dropdown__btn rounded__btn mr-10">
            <ArrowLeft />
          </Link>

          <span>
            Novo grupo de clientes
          </span>
        </div>
      </div>

      <div className="dashboard__container-chart">
        <div className="d-flex flex-column align-center justify-center dashboard__container">
          <div className="inner-profile-xl">
            <form onSubmit={onSubmit}>
              <Input label="Nome" type="text" placeholder="Adicione um nome" onChange={e => setName(e.target.value)} value={name} name="name" register={register} />

              <div className="mt-20 mb-20">
                <div className="inner-search">
                  <div className="search-icon">
                    <Search size={24} />
                  </div>

                  <input className="search-input" type="text" placeholder="Pesquisar"
                    onChange={e => setSearch(e.target.value)} value={search} />
                </div>
              </div>

              {!loading && contactsCount > 0
                && <div className="x-p-20 y-p-20 pt-0 text-color">{contactsCount} {contactsCount > 1 ? "contatos selecionados" : "contato selecionado"}</div>}

              <div>
                <ul className="contact__list">
                  {loading && <LoadingCenter />}

                  {!loading && contacts?.length <= 0 && <div className="x-p-20 y-p-10 text-color">Sem clientes.</div>}

                  {!loading && visible && <li className="contact__item x-p-20 y-p-10 d-flex flex-row align-center">
                    <div className="mr-20">
                      <CFormCheck onChange={onChangeAll} />
                    </div>

                    <span className="text-color">Selecionar tudo</span>
                  </li>}

                  {!loading && filteredConsumers?.map((contact, index) => {
                    return (
                      <li key={contact.id} className="contact__item x-p-20 y-p-10 d-flex flex-row align-center">
                        <div className="mr-20">
                          <CFormCheck name="contacts" value={contact.id} checked={contact.checked} onChange={event => onChangeCheck(event, contact)} />
                        </div>

                        <div className="mr-10">
                          <CAvatar color="light" textColor="dark" style={avatarStyle(contact.profile_pic)} />
                        </div>

                        <span className="text-color">{contact.name}</span>
                      </li>
                    );
                  })}
                </ul>
              </div>

              <div className="popup-footer x-p-20 y-p-20">
                <button className="btn btn-primary" type="submit" disabled={!(contactsCount > 0 && name != "")}>
                  {mutationChainsCreate.isLoading ? "Carregando..." : "Criar novo grupo"}
                </button>
              </div>
            </form>

          </div>
        </div>
      </div>
    </div >
  );
}

export default ChainsNew;